var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-my-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-shopping-cart" }
          }),
          _vm._v(" Resgates\n  ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          staticClass: "text-primary",
          attrs: { align: "center" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "PendingRewards",
              label: "Resgates Pendentes"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "RedeemHistory",
              label: "Histórico de Resgates"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "PendingRewards" } },
            [_c("pending-rewards")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "RedeemHistory" } },
            [_c("redeem-history")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }